(function () {
    "use strict";

    angular
        .module("app")
        .directive("activityTypeSearchHelp", ["SearchFactory", activityTypeSearchHelp]);

    function activityTypeSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.activityTypeName = "";
                        scope.activityTypeKey = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.activityTypeName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.activityTypeSearch(function (activityType) {
                        scope.activityTypeKey = activityType ? activityType.CharacteristicValue : "";
                        scope.activityTypeName = activityType ? activityType.CharacteristicDesc : "";
                        scope.displayValue = scope.activityTypeKey;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue, ""]);
                };

                scope.$watch("activityTypeKey", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.activityTypeName;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { activityTypeKey: "=", activityTypeName: "=", readOnly: "=", required: "=", controlName: "@", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

